import { useState } from "react";

import { Button, Form, Input, Space } from "antd";

const ProductNav = ({
	categoryList,
	subCategoryList,
	handleCategory,
	category,
	setCategory,
	handleSubCategory,
	subCategory,
	setSubCategory,
	handleSearch,
}) => {
	const [searchValue, setSearchValue] = useState(null);

	return (
		<div className={`product-search-wrap`}>
			{/*<Form size={`large`}>*/}
			{/*	<Input.Search*/}
			{/*		type={`text`}*/}
			{/*		placeholder={`영양제명, 브랜드를 검색해보세요!`}*/}
			{/*		allowClear*/}
			{/*		value={searchValue}*/}
			{/*		onChange={(e) => {*/}
			{/*			setSearchValue(e.target.value);*/}
			{/*		}}*/}
			{/*		onSearch={() => handleSearch(searchValue)}*/}
			{/*	/>*/}
			{/*</Form>*/}
			<Space className={`category-list-div`}>
				{categoryList.map((item, idx) => (
					<Button
						key={`카테고리 리스트 ${idx}`}
						value={item.category_id}
						className={`${
							item.category_id === "all" ? "sub-category-all" : "sub-category"
						} ${item.category_id === category.category_id ? "clicked" : ""}`}
						onClick={() => {
							handleCategory(item);
							setCategory(item);
							setSearchValue(null);
						}}
					>
						{item.category_name}
					</Button>
				))}
			</Space>

			{category.category_id !== "all" && (
				<Space wrap className={`sub-category-list-div`}>
					{subCategoryList.map((item, idx) => (
						<Button
							key={`서브 카테고리 리스트 ${idx}`}
							value={item.category_id}
							className={`${
								item.category_id === subCategory.category_id ? "clicked" : ""
							}`}
							onClick={() => {
								handleSubCategory(item);
								setSubCategory(item);
							}}
							shape="round"
						>
							{item.category_name}
							<span id={`count`}>({item.count})</span>
						</Button>
					))}
				</Space>
			)}
		</div>
	);
};

export default ProductNav;
